module.exports = __webpack_public_path__ + "img/img5.8420df5e.png";